// section: main-collection
class CollectionLayout extends HTMLElement {
  constructor() {
    super();

    var buttons = this.querySelectorAll("div[data-layout]");
    var collection = theme.utils.getParents(this, "main-collection");
    var activeButton = null;

    if (buttons) {
      buttons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          var products = collection.querySelectorAll(".collection__product");
          var layout = this.getAttribute("data-layout");
          this.classList.toggle("active");
          if (activeButton != null) activeButton.classList.toggle("active");
          activeButton = this;
          products.forEach((product) => {
            product.className =
              "flex__item collection__product aos-init aos-animate " + layout;
          });
        });
      });
    }
  }
}
customElements.define("collection-layout", CollectionLayout);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.defaultStep = 5;
    this.selectors = {
      priceRange: ".price-range",
      priceRangeSlider: ".price-range__slider",
      priceRangeInputMin: ".price-range__input-min",
      priceRangeInputMax: ".price-range__input-max",
      priceRangeDisplayMin: ".price-range__display-min",
      priceRangeDisplayMax: ".price-range__display-max",
      priceText: ".filters__price_selected",
    };

    this.container = this;
    this.sliderEl = this.container.querySelector(
      this.selectors.priceRangeSlider,
    );
    this.inputMinEl = this.container.querySelector(
      this.selectors.priceRangeInputMin,
    );
    this.inputMaxEl = this.container.querySelector(
      this.selectors.priceRangeInputMax,
    );
    this.displayMinEl = this.container.querySelector(
      this.selectors.priceRangeDisplayMin,
    );
    this.displayMaxEl = this.container.querySelector(
      this.selectors.priceRangeDisplayMax,
    );
    this.formEl = this.container.closest("form");
    this.priceTexteEl = this.formEl.querySelector(this.selectors.priceText);

    this.minRange = parseFloat(this.container.dataset.min) || 0;
    this.minValue = parseFloat(this.container.dataset.minValue) || 0;
    this.maxRange = parseFloat(this.container.dataset.max) || 100;
    this.maxValue =
      parseFloat(this.container.dataset.maxValue) || this.maxRange;

    try {
      this.createPriceRange();
    } catch (e) {
      console.log(e);
    }
  }

  createPriceRange() {
    if (
      this.sliderEl &&
      this.sliderEl.noUiSlider &&
      typeof this.sliderEl.noUiSlider.destroy === "function"
    ) {
      this.sliderEl.noUiSlider.destroy();
    }

    var slider = noUiSlider.create(this.sliderEl, {
      connect: true,
      step: this.defaultStep,
      start: [this.minValue, this.maxValue],
      range: {
        min: this.minRange,
        max: this.maxRange,
      },
    });

    slider.on("update", (values) => {
      this.displayMinEl.innerHTML = theme.Currency.formatMoney(
        parseFloat(values[0]),
        theme.moneyFormat,
      );
      this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
        parseFloat(values[1]),
        theme.moneyFormat,
      );

      if (this.priceTexteEl) {
        this.priceTexteEl.innerHTML =
          theme.Currency.formatMoney(parseFloat(values[0]), theme.moneyFormat) +
          " - " +
          theme.Currency.formatMoney(parseFloat(values[1]), theme.moneyFormat);
      }
    });

    slider.on("change", (values) => {
      console.log(values);
      this.inputMinEl.setAttribute("value", parseFloat(values[0] / 100));
      this.inputMaxEl.setAttribute("value", parseFloat(values[1] / 100));
      this.formEl.dispatchEvent(new Event("input", { bubbles: true }));
    });

    return slider;
  }
}
customElements.define("price-range", PriceRange);

class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = theme.utils.debounce(500, (event) => {
      event.target.classList.contains("filters__autocomplete-search-input") ||
        this.onSubmitHandler(event);
    });

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this),
    );
    window.addEventListener("popstate", this.onHistoryChange.bind(this));

    this.bindActivefilterButtonEvents();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    this.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActivefilters();
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state ? event.state.searchParams : "";
    this.renderPage(searchParams, null, false);
  }

  toggleActivefilters(disable = true) {
    document.querySelectorAll(".js-filter-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const sections = this.getSections();
    document.getElementById("productsGrid").classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      this.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl, section, event)
        : this.renderSectionFromFetch(url, section, event);
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderFilters(html, event);
        this.renderProductGrid(html);
        this.renderPagination(html);
      });
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
    if (document.querySelectorAll(".collection_pagination").length > 0)
      this.renderPagination(html);
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("productsGrid").innerHTML;
    document.getElementById("productsGrid").innerHTML = innerHTML;
    document.getElementById("productsGrid").classList.remove("loading");
  }

  renderPagination(html) {
    const pagination = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(".collection_pagination");
    if (document.querySelector(".collection_pagination")) {
      if (pagination) {
        document.querySelector(".collection_pagination").innerHTML =
          pagination.innerHTML;
      } else {
        document.querySelector(".collection_pagination").innerHTML = "";
      }
    }
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const filterDetailsElements = parsedHTML.querySelectorAll(
      "#CollectionFiltersForm .js-filter, #CollectionFiltersFormMobile .js-filter",
    );
    const matchesIndex = (element) =>
      (event
        ? event.target.closest(".js-filter")
          ? event.target.closest(".js-filter").dataset.index
          : ""
        : "") === element.dataset.index;
    const filtersToRender = Array.from(filterDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(filterDetailsElements).find(matchesIndex);
    filtersToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    this.renderActivefilters(parsedHTML);
    this.renderMobileElements(parsedHTML);

    if (countsToRender)
      this.renderCounts(countsToRender, event.target.closest(".js-filter"));
    const reloadFilter = new CustomEvent("reloadfilter");
    document.dispatchEvent(reloadFilter);
  }

  renderActivefilters(html) {
    const activefilterElementSelectors = [
      ".active-filters-mobile",
      ".active-filters-desktop",
    ];

    activefilterElementSelectors.forEach((selector) => {
      const activefiltersElement = html.querySelector(selector);
      if (!activefiltersElement) return;
      document.querySelector(selector).innerHTML =
        activefiltersElement.innerHTML;
    });

    this.bindActivefilterButtonEvents();
    this.toggleActivefilters(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = [
      ".mobile-filters__open",
      ".mobile-filters__count",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (document.querySelector(selector) && html.querySelector(selector)) {
        document.querySelector(selector).innerHTML =
          html.querySelector(selector).innerHTML;
      }
    });

    if (document.getElementById("CollectionFiltersFormMobile"))
      document
        .getElementById("CollectionFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = [".count-bubble", ".filters__selected"];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActivefilterButtonEvents() {
    document.querySelectorAll(".js-filter-remove").forEach((element) => {
      element.addEventListener("click", this.onActiveFilterClick, {
        once: true,
      });
    });
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  getSections() {
    return [
      {
        id: "main-collection-product-grid",
        section: document.getElementById("main-collection-product-grid").dataset
          .id,
      },
    ];
  }
}
customElements.define("collection-filters", CollectionFilters);

class AutocompleteFilter extends HTMLElement {
  constructor() {
    super(), (this.onInput = this.onInput.bind(this)), this.attachInputEvent();
  }
  connectedCallback() {
    this.attachInputEvent(),
      document.addEventListener("reloadfilter", () => {
        this.attachInputEvent();
      });
  }
  attachInputEvent() {
    (this.input = this.querySelector(".filters__autocomplete-search-input")),
      this.input &&
        (this.input.removeEventListener("input", this.onInput),
        this.input.addEventListener("input", this.onInput));
  }
  onInput(e) {
    let i = e.target.value.toLowerCase();
    e = this.closest(".filters__disclosure");
    e &&
      e.querySelectorAll(".filters__list .filters__item").forEach((e) => {
        let t = e.querySelector("label span").textContent.toLowerCase();
        (t = t.replace(/\s*\(\d+\)\s*$/, "")).includes(i)
          ? (e.style.display = "")
          : (e.style.display = "none");
      });
  }
}
customElements.define("autocomplete-filter", AutocompleteFilter);
